<!-- =========================================================================================
    File Name: designationForm.vue
    Description: Designation
    ----------------------------------------------------------------------------------------
    Item Name: KOZO Admin - VueJS Dashboard
    Author:
    Author URL:
========================================================================================== -->

<template>
  <div>
    <!-- ADD DESIGNATION FORM  -->
    <div class="vx-row">
      <!-- HORIZONTAL LAYOUT -->
      <div class="vx-col w-full">
        <vx-card class="form-title" title="Add Designation">
          <div class="vx-row col-12 d-flex justify-content-end">
            <div
              class="vs-component vs-button px-4 vs-button-primary vs-button-filled mb-5 mr-4 sm:mr-0"
            >
              <span class=" pr-5 px-2 py-3 text-white">Import</span>
              <img
                class="d-inline-flex"
                src="@/assets/images/icons/import-excel.svg"
                height="20"
                width="20"
              />
            </div>
            <div class="vx-col">
              <div class="">
                <vx-tooltip text="Template Excel" position="left">
                  <!-- <a :href="excelurl+`/department/excel/sample`" target="_blank"> -->
                  <vs-button
                    @click.native="
                      onClickSampleDownload(
                        excelurl +
                          `/v2/designation/excel/sample?organization_id=${organization_id}`
                      )
                    "
                    type="border"
                    class=" px-2 py-3"
                  >
                    <img
                      class="d-inline-flex mr-2"
                      src="@/assets/images/icons/excel.svg"
                      height="20"
                      width="20"
                    />Sample Excel
                  </vs-button>
                  <!-- </a> -->
                </vx-tooltip>
              </div>

              <div class="">
                <vx-tooltip text="Import Excel" position="left">
                  <label for="import-file">
                    <input
                      ref="uploadExcelFile"
                      @change="uploadExcel($event)"
                      type="file"
                      name="import-file"
                      id="import-file"
                      class="d-none"
                    />
                  </label>
                </vx-tooltip>
              </div>
            </div>
            <!-- <div class="vx-col">
              <div class="">
                <vx-tooltip text="Template Excel" position="left">
                  <vs-button
                    type="border"
                    class="px-2 py-3"
                    @click.native="
                      onClickSampleDownload(
                        excelurl + `/v2/category/excel/sample`
                      )
                    "
                  >
                    <img
                      class="d-inline-flex  mr-2"
                      src="@/assets/images/icons/excel.svg"
                      height="20"
                      width="20"
                    />Sample Excel
                  </vs-button>
                </vx-tooltip>
              </div>
            </div> -->
          </div>
          <form>
            <div class="vx-row">
              <!-- LEFT SIDE -->
              <div class="vx-col md:w-3/4 mx-auto">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full  align-self-center">
                    <h6 class="mb-0">Designation Name*</h6>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div class>
                      <vs-input
                        v-validate="'required|alpha_spaces'"
                        name="Designation Name"
                        v-model="form.designation_name"
                        class="w-full"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Designation Name')"
                        >{{ errors.first("Designation Name") }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full  align-self-center">
                    <h6 class="mb-0">Company*</h6>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <!-- Start ************* -->
                    <div>
                      <multiselect
                        v-model="value"
                        track-by="company_id"
                        label="company_name"
                        @input="
                          ({ company_id }) =>
                            (this.form.company_id = company_id)
                        "
                        :options="companies"
                        name="Company Name"
                        :searchable="true"
                        :allow-empty="false"
                        open-direction="bottom"
                        deselect-label="Can't remove this value"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          {{ option.company_name }}
                        </template>
                      </multiselect>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Company Name')"
                        >{{ errors.first("Company Name") }}</span
                      >
                    </div>
                    <!-- ************* End -->
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full ">
                    <h6 class="mb-0">Description</h6>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-textarea
                      v-model="designation_description"
                      class="mb-0"
                      rows="4"
                    />
                  </div>
                </div>
                <!-- Must have a value that is in the specified list : 1 or 3 -->
                <div class="vx-row mb-6">
                  <!-- <vs-select
                  v-validate="'included:1,2,3,4,5'"
                  v-model="role_id"
                  name="included"
                  label="Roles*"
                  class="select-large mt-5 w-full"
                  >-->

                  <!-- <span
                  class="text-danger text-sm"
                  v-show="errors.has('included')"
                  >{{ errors.first('included') }}</span>-->
                  <div class="vx-col sm:w-1/5 w-full">
                    <h6 class="mb-0">Status*</h6>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch v-model="switch1" />
                  </div>
                </div>
              </div>
            </div>

            <!-- SUBMIT BUTTON -->
            <div class="vx-row">
              <div class="vx-col mx-auto">
                <vs-button
                  :disabled="submitStatus"
                  type="filled"
                  @click.prevent="submitForm"
                  class="mr-3 mb-1 w-full sm:w-auto"
                  >Submit</vs-button
                >

                <vs-button
                  color="warning"
                  type="border"
                  class="mb-1 w-full sm:w-auto"
                  @click.prevent="clearForm"
                  >Reset</vs-button
                >
              </div>
              <!-- <div class="vx-col">
                <div class="excel-btn-1">
                  <vx-tooltip text="Template Excel" position="left">
                    <vs-button
                      type="border"
                      class="py-2"
                      @click.native="
                        onClickSampleDownload(
                          excelurl +
                            `/v2/designation/excel/sample?organization_id=${organization_id}`
                        )
                      "
                    >
                      <img
                        class="d-inline-flex"
                        src="@/assets/images/icons/excel.svg"
                        height="20"
                        width="20"
                      />
                    </vs-button>
                  </vx-tooltip>
                </div>

                <div class="excel-btn-2">
                  <vx-tooltip text="Import Excel" position="left">
                    <label for="import-file">
                      <input
                        ref="uploadExcelFile"
                        @change="uploadExcel($event)"
                        type="file"
                        name="import-file"
                        id="import-file"
                        class="d-none"
                      />
                      // class="d-none" 
                      <div
                        class="vs-component vs-button px-4 vs-button-primary vs-button-filled"
                      >
                        <span class="d-inline-flex pr-5 text-white"
                          >Import</span
                        >
                        <img
                          class="d-inline-flex"
                          src="@/assets/images/icons/import-excel.svg"
                          height="20"
                          width="20"
                        />
                      </div>
                    </label>
                  </vx-tooltip>
                </div>
              </div> -->
            </div>
          </form>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import contacts from "../../ui-elements/ag-grid-table/data.json";
import DatetimePickerStartEnd from "@/views/components/extra-components/datetime-picker/DatetimePickerStartEnd.vue";
import DesignationService from "@/services/designationService.js";
import CompanyService from "@/services/companyService.js";
import axios from "axios";

const VxTour = () => import("@/components/VxTour.vue");

import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { BASEURL } from "@/config/index.js";
export default {
  components: {
    AgGridVue,
    VxTour,
    DatetimePickerStartEnd,
  },
  data() {
    return {
      excelurl: BASEURL,
      submitStatus: true,
      switch1: true,
      designation_description: "",
      form: {
        company_id: "",
        designation_name: "",
        designation_active: 1,
      },
      value: [],
      companies: [],
      User: "Select User",
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      fromDate: null,
      toDate: null,
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,
      },
      configTodateTimePicker: {
        minDate: null,
      },
      cityOptions: [
        { text: "New York", value: "new-york" },
        { text: "Chicago", value: "chicago" },
        { text: "San Francisco", value: "san-francisco" },
        { text: "Boston", value: "boston" },
      ],
      columnDefs: [
        {
          headerName: "User Name",
          field: "firstname",
          width: 275,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Expense Head",
          field: "lastname",
          filter: true,
          width: 275,
        },
        {
          headerName: "Expense Category",
          field: "email",
          filter: true,
          width: 375,
          //   pinned: "left"
        },
        {
          headerName: "Amount (₹)",
          field: "company",
          filter: true,
          width: 200,
        },
        {
          headerName: "Expense Date",
          field: "city",
          filter: true,
          width: 200,
        },
        {
          headerName: "Status",
          field: "state",
          filter: true,
          width: 150,
        },
      ],
      contacts: contacts,
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },
    form: {
      handler: function(newVal, oldVal) {
        let len = Object.keys(this.form).length;
        if (
          len ===
          Object.keys(newVal).filter(
            (x, index) =>
              newVal[x] &&
              newVal[x] !== undefined &&
              String(newVal[x]).trim().length > 0
          ).length
        ) {
          this.submitStatus = false;
        } else {
          this.submitStatus = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    organization_id() {
      return localStorage.getItem("OrganizationID");
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    onClickSampleDownload: function(URL) {
      window.open(URL, "_blank");
    },
    uploadExcel: function(event) {
      let that = this;
      that.$vs.loading();
      let formData = new FormData();
      formData.append("file", event.target.files[0]);
      axios
        .post(
          that.excelurl +
            `/v2/designation/import/excel?organization_id=${
              this.organization_id
            }`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          const { data } = response;
          const input = this.$refs.uploadExcelFile;
          input.type = "text";
          input.type = "file";
          if (
            data &&
            data["error"] &&
            data.error["message"] &&
            data.error.message.length > 0
          ) {
            that.$vs.notify({
              // title: "Duplicate entries have not been imported.",
              title: "Error!",
              text: data.error.message || "Error",
              iconPack: "feather",
              // time:8000,
              time: 35000,
              icon: "check_box",
              color: "warning",
            });
          } else {
            that.$vs.notify({
              title: "Updated!",
              text: data.data.message || "Updated",
              iconPack: "feather",
              icon: "check_box",
              color: "success",
            });
          }
          that.$vs.loading.close();
          // that.$vs.notify({
          //   title: "Updated!",
          //   text: data.message,
          //   iconPack: "feather",
          //   icon: "check_box",
          //   color: "success"
          // });
          eventBus.$emit("refreshTabledesi", data);
        })
        .catch((error) => {
          that.$vs.loading.close();
          const input = this.$refs.uploadExcelFile;
          input.type = "text";
          input.type = "file";
          that.$vs.notify({
            title: "Error!",
            text: error.message,
            iconPack: "feather",
            icon: "check_box",
            color: "warning",
          });
        });
    },
    getCompanyList: function() {
      // console.log("RolesService :", RolesService);
      CompanyService.getAllCompanies()
        .then((response) => {
          const { data } = response;
          if (data.err || data.Status == false) {
          } else {
            this.companies = data.data;
            // if (this.companies.length > 0) {
            //   this.form.company_id = this.companies[0].company_id;
            // }
          }
        })
        .catch((error) => {
          console.log("error :", error);
        });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();

          this.submitStatus = false;
          let payload = {
            company_id: this.form.company_id,
            designation_name: this.form.designation_name,
            designation_description: this.designation_description,
            designation_active: this.switch1 ? "1" : "2",
          };
          DesignationService.addDesignation(payload)
            .then((response) => {
              this.submitStatus = false;

              const { data } = response;
              this.$vs.loading.close();

              if (data.Status == true || data.Status == "true") {
                this.$vs.notify({
                  title: "Created!",
                  text: data.Message,

                  iconPack: "feather",
                  icon: "check_box",
                  color: "success",
                });
                this.clearForm();
                setTimeout(() => {
                  eventBus.$emit("refreshTabledesi", data);
                }, 1);
              } else {
                console.log("data :", data);
                this.$vs.notify({
                  title: "Error!",
                  text: data.Message,
                  iconPack: "feather",
                  icon: "check_box",
                  color: "warning",
                });
              }
            })
            .catch((error) => {
              this.submitStatus = true;
              console.log("error :", error);
            });
          // if form have no errors
          // alert("form submitted!");
        } else {
          // form have errors
        }
      });
    },
    clearForm: function() {
      Object.keys(this.form).map((x, index) => {
        /_active/.test(x) ? (this.form[x] = "1") : (this.form[x] = "");
      });
      this.designation_description = "";
      this.value = [];
      this.$validator.reset();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
  },
  mounted() {
    this.getCompanyList();
    this.gridApi = this.gridOptions.api;
  },
};
</script>
